module.exports = __webpack_public_path__ + "img/大城保温材料.4ad07dc7.jpg";